export default __webpack_public_path__ + "static/media/bronzeBadge.346c0d61.svg";